// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Application/types/SafetyBarrier/styles.scss
// module id = 1238
// module chunks = 0